module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "i": "components-photobrowser"
    }
  }, [_c('ul', {
    attrs: {
      "id": "photobrowser"
    }
  }, [(_vm.type == 1) ? [_c('li', [_c('img', {
    attrs: {
      "data-original": _vm.imgData,
      "src": _vm.imgData,
      "alt": "图片1"
    }
  })])] : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _vm._l((_vm.imgData), function(data, index1) {
    return _c('li', {
      key: index1
    }, [_c('img', {
      attrs: {
        "data-original": _vm.param.name ? (data[_vm.param.name] ? data[_vm.param.name] : data) : data,
        "src": _vm.param.name ? (data[_vm.param.name] ? data[_vm.param.name] : data) : data,
        "alt": _vm.param.detail ? data[_vm.param.detail] : '图片' + index1
      }
    })])
  }) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? [_c('li', [_c('img', {
    attrs: {
      "data-original": _vm.imgData[_vm.param.name],
      "src": _vm.imgData[_vm.param.name],
      "alt": _vm.param.detail ? (_vm.imgData[_vm.param.detail] ? _vm.imgData[_vm.param.detail] : '图片' + _vm.index) : '图片' + _vm.index
    }
  })])] : _vm._e()], 2)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-7dfd8050!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/photobrowser/Photobrowser.vue
// module id = 1030
// module chunks = 59